/**
 * Types of notifications.
 * @since 4.0.0
 * 
 * @see {@link notify|DMS.Navigation.notify} for usage.
 */
export enum NotificationTypes {
    /**
     * Error notification.
     * @since 4.0.0
     */
    Error = 1,

    /**
     * Information notification.
     * @since 4.0.0 
     */
    Info = 2,

    /**
     * Success notification.
     * @since 4.0.0
     */
    Success = 3
}
